import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { CSSTransition } from "react-transition-group";
import { Placeholder } from "rsuite";
import { UserContext } from "../components/authProvider/main";
import { ParametersGlobals } from "../core/parametersGlobals/ParametersGlobals";
import { LoginAnimationSvg } from "../svg/LoginAnimationSvg";
import { ModuleBlock } from "./modules/ModuleBlock";
import { ModuleContainer } from "./modules/ModuleContainer";

const { Paragraph } = Placeholder;
class ModulesPage extends React.Component<any, {}> {
  static contextType?: React.Context<any> | undefined = UserContext;

  public constructed = false;

  public state = {
    isMounted: false,
    configModules: [],
  };

  public nodeRef: any = null;

  constructor(props: any) {
    super(props);
    this.nodeRef = React.createRef();
  }

  componentDidUpdate() {}

  componentDidMount = () => {
    this.setState({ isMounted: true });
  };

  goTo(link: string) {
    this.props.history.push(link);
  }

  renderModules = (variableName = "modules") => {
    const configModule = (this.context as any).data.modulesReturn;
    var output = [];
    let index = 0;
    for (const i in configModule) {
      let moduleData: any = configModule[i];
      index += 1.5;
      if (moduleData.module_visible_dashboard) {
        output.push(
          <ModuleBlock
            key={i}
            visible={moduleData.module_visible_dashboard}
            color={moduleData.module_color}
            delay={index}
            onClick={() => this.goTo("/dashboard/" + moduleData.module_url)}
            icon={moduleData.module_icon}
            name={moduleData.module_label}
          />
        );
      }
    }
    return output;
  };

  render() {
    return (
      <div>
        <Helmet>
          <title>{`${ParametersGlobals.projectTitle}`}</title>
        </Helmet>

        <CSSTransition
          nodeRef={this.nodeRef}
          in={this.state.isMounted}
          timeout={200}
          unmountOnExit
          classNames="fade"
        >
          <div className="modules-page">
            <LoginAnimationSvg />

            <ModuleContainer size={3} title="Módulos">
              {(this.context as any).data ? ( 
                  <>
                    {this.renderModules()}
                  </>
              ) : (
                <>
                  <Paragraph />
                </>
              )}
            </ModuleContainer>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default withRouter(ModulesPage);
